import axios from 'axios';
import endpoints from '@configs/endpoints';
import debug from 'debug';

const err = debug('LogPayment:error');

const logPayment = (data: any): void => {
  axios
    .post(endpoints.logsPayment, {
      businessId: data.businessId,
      parentPartnerId: data?.parentPartnerId || '',
      type: data.type,
      source: data.source,
      paymentPartner: data.paymentPartner,
      paymentMethod: data.paymentMethod,
      key: data.key,
      code: data.code,
      description: data.description,
      metadata: data.metadata,
      paymentLinkId: data.paymentLinkId,
    })
    .catch((e) => err('Something went sending the payment log %o', e));
};
export default logPayment;
